import { render, staticRenderFns } from "./paging-footer.vue?vue&type=template&id=b13e243c"
import script from "./paging-footer.vue?vue&type=script&lang=js"
export * from "./paging-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2251928234/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b13e243c')) {
      api.createRecord('b13e243c', component.options)
    } else {
      api.reload('b13e243c', component.options)
    }
    module.hot.accept("./paging-footer.vue?vue&type=template&id=b13e243c", function () {
      api.rerender('b13e243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/paging-footer.vue"
export default component.exports